import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["value", "outlet"];
  static values = { translations: Object };

  connect() {
    this.updateDirection(this.valueTarget);
  }

  angleChanged({ target }) {
    this.updateDirection(target);
  }

  updateDirection({ value }) {
    const direction = this.constructor.angleToDirection(value);
    this.outletTarget.innerText = this.translationsValue[direction];
  }

  static angleToDirection(value) {
    const angle = parseInt(value, 10);
    const octant = Math.floor(((angle + 22.5) % 360) / 45);

    return ["s", "sw", "w", "nw", "n", "ne", "e", "se"][octant];
  }
}
